import { NgModule } from '@angular/core';
import { SiteFileUploadComponent } from './site-file-upload.component';
import { SiteCommonModule } from '@widgets/site-common/site-common.module';
import { FileUploadModule } from '@iplab/ngx-file-upload';

@NgModule({
  declarations: [SiteFileUploadComponent],
  imports: [SiteCommonModule, FileUploadModule],
  exports: [SiteFileUploadComponent]
})
export class SiteFileUploadModule {}
